<script setup lang="ts">
import { ref } from 'vue';
import Dialog from 'primevue/dialog';
import Checkbox from 'primevue/checkbox';
import { useI18n } from 'vue-i18n';
import { ButtonType, CustomButton } from '../common';
import { useStudyStore } from '@/stores/study';

defineProps({
  visible: {
    type: Boolean,
    required: true
  }
});

const studyStore = useStudyStore();

const { t: $t } = useI18n();
const flatOptions = ref();
const emits = defineEmits(['onClose']);

const closeDialog = () => {
  emits('onClose');
};

const createExport = async () => {
  await studyStore.getExport({ flatHumanReadableOptions: flatOptions.value || false });
  closeDialog();
};

</script>

<template>
    <Dialog :visible="visible"
    modal
    header="Schema Export"
    class="dialog"
    style="width: 600px"
    @update:visible="closeDialog">
    <div class="archive-group-grid">
      <div class="group-grid">
        <div class="group flat-options">
            <div class="flat-label">Flat human-readable options</div>
            <FontAwesomeIcon :icon="[`fas`, `square-info`]"
                v-tooltip="$t('flat-options')"
                class="flat-tooltip"/>
            <Checkbox v-model="flatOptions"
                inputId="flat-options"
                name="flat-options"
                value="flat-options"/>
        </div>
      </div>
    <div class="buttons">
      <CustomButton text="Cancel"
        :type="ButtonType.OUTLINED"
        @onClick="closeDialog"/>
      <CustomButton text="Create Export"
        :type="ButtonType.POSITIVE"
        :marginLeft="16"
        :loading="studyStore.importExportLoader.isLoading"
        @onClick="createExport"/>
    </div>
    </div>
   </Dialog>
</template>

<style scoped lang="scss">
.buttons {
  display: flex;
  justify-content: flex-end;
}
.group.flat-options {
  display: flex;
  align-items: center;

  .flat-label {
    margin-right: 16px;
  }
}
.flat-tooltip {
    margin-right: 8px;
}
.group-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 24px;
  margin-bottom: 16px;
}
</style>
